// vuex / store / actions
export default {
  // example:
  // doAction({commit}, data) {
  //   commit('MUTA_NAME', data)
  // },
  setGapi ({ commit }, data) {
    commit('SET_GAPI', data)
  },
  setUserEmail ({ commit }, data) {
    commit('SET_USER_EMAIL', data)
  },
  addUserCaches ({ commit }, data) {
    commit('ADD_USER_CACHES', data)
  },

  // # ms - new actions
  // ---------------------
  setMsal ({ commit }, data) {
    commit('SET_MSAL', data)
  },
  setAccess ({ commit }, data) {
    commit('SET_ACCESS', data)
  }
  // ---------------------
}
